export default {
    parts: ['container',
        'imageWrapper',
        'wrapper',
        'title',
        'description',
        'ctasContainer',
        'logoMedia',
        'subTitle',
        'subTitleDescription',
        'gridDivider',
        'ctaPreTitle',
        'ctaTitle',
        'ctaItemsContainer',
        'ctaItemContainer',
        'carouselCtaItems'],
    baseStyle: (props) => ({
        container: {
            display: { lg: 'flex' },
            padding: 0
        },
        imageWrapper: {
            flex: { lg: '0 0 50%' },
            maxWidth: { lg: '50%' }
        },
        wrapper: {
            position: 'relative',
            flex: { lg: '0 0 50%' },
            maxWidth: { lg: '50%' },
            padding: { base: '32px 16px 80px', lg: '48px 24px 24px 48px' },
            backgroundColor: { base: props?.BackgroundColorPicker || 'warmWhite' }
        },
        title: {
            fontSize: { base: 'xl', lg: '2xl' },
            lineHeight: { base: '100%', lg: '30px' },
            marginBottom: { base: 4 },
            textTransform: { base: 'uppercase' }
        },
        subTitle: {
            fontSize: { base: 'sm' },
            lineHeight: { base: '16px' },
            textTransform: { base: 'uppercase' }
        },
        subTitleDescription: {
            fontSize: { base: 'xs' },
            lineHeight: { base: '15px' }
        },
        description: {
            fontSize: { base: 'md' },
            lineHeight: { base: '24px' },
            marginBottom: { base: 10, lg: '76px' }
        },
        logoMedia: {
            width: { base: '114px' },
            marginBottom: { base: 10 }
        }
    }),
    variants: {
        'Grid': (props) => ({
            ctasContainer: {
                padding: { base: '16px', lg: 0 },
                ...(props?.CTABackgroundColor && props?.CTABackgroundColor !== '' && {
                    backgroundColor: {
                        base: props?.CTABackgroundColor || props?.BackgroundColorPicker || 'warmWhite',
                        lg: props?.BackgroundColorPicker || 'warmWhite'
                    }
                })
            },
            subTitle: {
                fontSize: { base: 'md' },
                lineHeight: { base: '16px' },
                marginBottom: { base: 1 }
            },
            ctaItemsContainer: {
                marginTop: { base: 6, lg: 0 },
                alignItems: { base: 'stretch' },
                gap: { lg: 6 }
            },
            ctaItemContainer: {
                justifyContent: { base: 'space-between' },
                padding: { base: '6px 0', lg: 0 },
                gap: 0
            },
            gridDivider: {
                marginRight: { base: props?.CtaGap },
                marginLeft: { base: props?.CtaGap },
                borderColor: { base: 'black' },
                height: { base: 'auto' }
            },
            ctaTitle: {
                fontSize: { base: 'xs' },
                lineHeight: { base: '15px' },
                color: { base: 'grey.700' },
                marginBottom: { base: 1 }
            },
            ctaPreTitle: {
                fontSize: { base: 'xs' },
                lineHeight: { base: '15px' },
                color: { base: 'black' },
            }
        }),
        'Carousel': (props) => ({
            wrapper: {
                padding: { base: '32px 16px 80px', lg: '72px 24px 24px 48px' },
            },
            ctasContainer: {
                marginRight: { base: '-16px', lg: 0 }
            },
            carouselCtaItems: {
                display: { lg: 'flex' },
                flexWrap: { lg: 'wrap' },
                ...(props?.CtaGap && {
                    gap: { lg: props?.CtaGap }
                }),
            },
            subTitle: {
                fontSize: { base: 'md' },
                lineHeight: { base: '20px' },
                marginBottom: { base: 4 }
            }
        })
    }
}
